export const UI_LABEL = {
  // Tires
  season: "Season",
  speedRating: "Speed Rating",
  loadIndex: "Load Index",
  model: "Model",
  // Wheels
  series: "Series",
  size: "Size",
  offset: "Off Set",
  surfaceFinish: "Surface Finish",
  widthInMm: "Tire Size",
};

export const UI_LABEL_FOR_TABLE = {
  ...UI_LABEL,
  diameterInInches: "Diameter In Inches",
  widthInMm: "width In mm",
  profile: "Profile",
  construction: "Construction",
  // Wheels
  boltpattern: "Bolt Pattern",
  centerbore: "Center Bore",
  loadrating: "Load Rating",
  wintercompatible: "Winter Compatible",
  seattype: "Seat Type",
  boltholeinner: "Bolt Hole Inner",
  xfactor: "X Factor",
  upc: "UPC",
  offset: "Offset",
  surfaceFinish: "Surface Finish",
  boltholeouter: "Bolt Hole Router",
  centercap: "Center Cap",
  yfactor: "Y Factor",
  size: "Size",
  series: "Series",
  centerboregap: "Center Bore Gap",
  model: "OEM",
};
